import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-service-incometax',
  templateUrl: './service-incometax.component.html',
  styleUrls: ['./service-incometax.component.css']
})
export class ServiceIncometaxComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    window.scrollTo(0, 0);
  }

}
